import { InjectionToken } from '@angular/core';
import { Route } from '@angular/router';
import { MODULE_LIST, ModuleType, PackageType } from '@contracts';
import { Observable } from 'rxjs';

export interface AppRouteConfig {
  siteName: string;
  logoPath?: string;
  version: string;
  package: PackageType | string;
  bg_offline_dashboard?: string;
  moduleRoutes: Record<string, Route[]>;
  defaultRoutes: Record<string, string>;
  defaultModule?: ModuleType;
  module_menu: Observable<MODULE_LIST[]>;
}

export const APP_ROUTES_CONFIG = new InjectionToken<AppRouteConfig>(
  'APP_ROUTES_CONFIG',
);
